module.exports = __webpack_public_path__ + "img/yiyangjiehe.69ed9742.png";